import toast from '@/common/toast';
import emptyInnerHTML from '@/common/helpers/empty-inner-html';
import StoreMappingMixin from '@/mixins/store-mapping-mixin';

export default function CommonUtils() {
    return {
        /* eslint-disable func-names */
        /* eslint-disable object-shorthand */
        install: function (Vue) {
            Vue.prototype.$clonePlainObject = function (scoped) {
                if (scoped) {
                    try {
                        // do a dirty copy of the stored object
                        return JSON.parse(JSON.stringify(scoped));
                    } catch (err) {
                        // hide any errors
                    }
                }
                return null;
            };
            Vue.prototype.$toast = toast;
            Vue.prototype.$isSandboxMode = function () {
                return this.$store.state.app.isSandbox;
            };
            Vue.prototype.$emptyInnerHTML = function () {
                return emptyInnerHTML;
            };
            Vue.prototype.$redirectOnError = function (error, to) {
                // when not canceling proceed to redirect to
                // the intended location
                if (error.name !== 'RebillyCanceledError') {
                    this.$router.push(to);
                }
            };
            // Add common store mapping.
            Vue.mixin(StoreMappingMixin);
        },
    };
}
